import { getThemeValue, spaceInPx, Box } from '@leagueplatform/ui-kit';
import styled from 'styled-components';

export const TabList = styled(Box)`
  box-sizing: border-box;
  /* Gives the bottom edge a border inside the box */
  box-shadow: 0 -1px 0 ${getThemeValue('colors.neutral.grayLight')} inset;
  margin-bottom: ${spaceInPx(2)};
`;
